import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ReportsIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Reports`} {...props}>
    <Path
      fill="currentColor"
      d="M3 8.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V9A.75.75 0 0 1 3 8.25Zm5-8a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 8 .25Zm5 5a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Z"
    />
  </Icon>
);
